// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-e7e86f59] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.avatardiv[data-v-e7e86f59] {
  position: relative;
  display: inline-block;
  width: var(--size);
  height: var(--size);
}
.avatardiv--unknown[data-v-e7e86f59] {
  position: relative;
  background-color: var(--color-main-background);
  white-space: normal;
}
.avatardiv[data-v-e7e86f59]:not(.avatardiv--unknown) {
  background-color: var(--color-main-background) !important;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.05) inset;
}
.avatardiv--with-menu[data-v-e7e86f59] {
  cursor: pointer;
}
.avatardiv--with-menu .action-item[data-v-e7e86f59] {
  position: absolute;
  top: 0;
  left: 0;
}
.avatardiv--with-menu[data-v-e7e86f59] .action-item__menutoggle {
  cursor: pointer;
  opacity: 0;
}
.avatardiv--with-menu[data-v-e7e86f59]:focus-within .action-item__menutoggle, .avatardiv--with-menu[data-v-e7e86f59]:hover .action-item__menutoggle, .avatardiv--with-menu.avatardiv--with-menu-loading[data-v-e7e86f59] .action-item__menutoggle {
  opacity: 1;
}
.avatardiv--with-menu:focus-within img[data-v-e7e86f59], .avatardiv--with-menu:hover img[data-v-e7e86f59], .avatardiv--with-menu.avatardiv--with-menu-loading img[data-v-e7e86f59] {
  opacity: 0.3;
}
.avatardiv--with-menu[data-v-e7e86f59] .action-item__menutoggle,
.avatardiv--with-menu img[data-v-e7e86f59] {
  transition: opacity var(--animation-quick);
}
.avatardiv--with-menu[data-v-e7e86f59]  .button-vue,
.avatardiv--with-menu[data-v-e7e86f59]  .button-vue__icon {
  height: var(--size);
  min-height: var(--size);
  width: var(--size) !important;
  min-width: var(--size);
}
.avatardiv--with-menu[data-v-e7e86f59] >  .button-vue, .avatardiv--with-menu[data-v-e7e86f59] >  .action-item .button-vue {
  --button-radius: calc(var(--size) / 2);
}
.avatardiv .avatardiv__initials-wrapper[data-v-e7e86f59] {
  display: block;
  height: var(--size);
  width: var(--size);
  background-color: var(--color-main-background);
  border-radius: calc(var(--size) / 2);
}
.avatardiv .avatardiv__initials-wrapper .avatardiv__initials[data-v-e7e86f59] {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  text-align: center;
  font-weight: normal;
}
.avatardiv img[data-v-e7e86f59] {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.avatardiv .material-design-icon[data-v-e7e86f59] {
  width: var(--size);
  height: var(--size);
}
.avatardiv .avatardiv__user-status[data-v-e7e86f59] {
  box-sizing: border-box;
  position: absolute;
  right: -4px;
  bottom: -4px;
  min-height: 14px;
  min-width: 14px;
  max-height: 18px;
  max-width: 18px;
  height: 40%;
  width: 40%;
  line-height: 1;
  font-size: clamp(var(--font-size-small, 13px), 85%, var(--default-font-size));
  border: 2px solid var(--color-main-background);
  background-color: var(--color-main-background);
  background-repeat: no-repeat;
  background-size: 16px;
  background-position: center;
  border-radius: 50%;
}
.acli:hover .avatardiv .avatardiv__user-status[data-v-e7e86f59] {
  border-color: var(--color-background-hover);
  background-color: var(--color-background-hover);
}
.acli.active .avatardiv .avatardiv__user-status[data-v-e7e86f59] {
  border-color: var(--color-primary-element-light);
  background-color: var(--color-primary-element-light);
}
.avatardiv .avatardiv__user-status--icon[data-v-e7e86f59] {
  border: none;
  background-color: transparent;
}
.avatardiv .popovermenu-wrapper[data-v-e7e86f59] {
  position: relative;
  display: inline-block;
}
.avatar-class-icon[data-v-e7e86f59] {
  display: block;
  border-radius: calc(var(--size) / 2);
  background-color: var(--color-background-darker);
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcAvatar-5N7xP8zN.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,mBAAmB;AACrB;AACA;EACE,yDAAyD;EACzD,6CAA6C;AAC/C;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,eAAe;EACf,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;;EAEE,0CAA0C;AAC5C;AACA;;EAEE,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;EAC9C,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,UAAU;EACV,cAAc;EACd,6EAA6E;EAC7E,8CAA8C;EAC9C,8CAA8C;EAC9C,4BAA4B;EAC5B,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,2CAA2C;EAC3C,+CAA+C;AACjD;AACA;EACE,gDAAgD;EAChD,oDAAoD;AACtD;AACA;EACE,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,oCAAoC;EACpC,gDAAgD;EAChD,YAAY;AACd","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-e7e86f59] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.avatardiv[data-v-e7e86f59] {\n  position: relative;\n  display: inline-block;\n  width: var(--size);\n  height: var(--size);\n}\n.avatardiv--unknown[data-v-e7e86f59] {\n  position: relative;\n  background-color: var(--color-main-background);\n  white-space: normal;\n}\n.avatardiv[data-v-e7e86f59]:not(.avatardiv--unknown) {\n  background-color: var(--color-main-background) !important;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.05) inset;\n}\n.avatardiv--with-menu[data-v-e7e86f59] {\n  cursor: pointer;\n}\n.avatardiv--with-menu .action-item[data-v-e7e86f59] {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.avatardiv--with-menu[data-v-e7e86f59] .action-item__menutoggle {\n  cursor: pointer;\n  opacity: 0;\n}\n.avatardiv--with-menu[data-v-e7e86f59]:focus-within .action-item__menutoggle, .avatardiv--with-menu[data-v-e7e86f59]:hover .action-item__menutoggle, .avatardiv--with-menu.avatardiv--with-menu-loading[data-v-e7e86f59] .action-item__menutoggle {\n  opacity: 1;\n}\n.avatardiv--with-menu:focus-within img[data-v-e7e86f59], .avatardiv--with-menu:hover img[data-v-e7e86f59], .avatardiv--with-menu.avatardiv--with-menu-loading img[data-v-e7e86f59] {\n  opacity: 0.3;\n}\n.avatardiv--with-menu[data-v-e7e86f59] .action-item__menutoggle,\n.avatardiv--with-menu img[data-v-e7e86f59] {\n  transition: opacity var(--animation-quick);\n}\n.avatardiv--with-menu[data-v-e7e86f59]  .button-vue,\n.avatardiv--with-menu[data-v-e7e86f59]  .button-vue__icon {\n  height: var(--size);\n  min-height: var(--size);\n  width: var(--size) !important;\n  min-width: var(--size);\n}\n.avatardiv--with-menu[data-v-e7e86f59] >  .button-vue, .avatardiv--with-menu[data-v-e7e86f59] >  .action-item .button-vue {\n  --button-radius: calc(var(--size) / 2);\n}\n.avatardiv .avatardiv__initials-wrapper[data-v-e7e86f59] {\n  display: block;\n  height: var(--size);\n  width: var(--size);\n  background-color: var(--color-main-background);\n  border-radius: calc(var(--size) / 2);\n}\n.avatardiv .avatardiv__initials-wrapper .avatardiv__initials[data-v-e7e86f59] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 100%;\n  text-align: center;\n  font-weight: normal;\n}\n.avatardiv img[data-v-e7e86f59] {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.avatardiv .material-design-icon[data-v-e7e86f59] {\n  width: var(--size);\n  height: var(--size);\n}\n.avatardiv .avatardiv__user-status[data-v-e7e86f59] {\n  box-sizing: border-box;\n  position: absolute;\n  right: -4px;\n  bottom: -4px;\n  min-height: 14px;\n  min-width: 14px;\n  max-height: 18px;\n  max-width: 18px;\n  height: 40%;\n  width: 40%;\n  line-height: 1;\n  font-size: clamp(var(--font-size-small, 13px), 85%, var(--default-font-size));\n  border: 2px solid var(--color-main-background);\n  background-color: var(--color-main-background);\n  background-repeat: no-repeat;\n  background-size: 16px;\n  background-position: center;\n  border-radius: 50%;\n}\n.acli:hover .avatardiv .avatardiv__user-status[data-v-e7e86f59] {\n  border-color: var(--color-background-hover);\n  background-color: var(--color-background-hover);\n}\n.acli.active .avatardiv .avatardiv__user-status[data-v-e7e86f59] {\n  border-color: var(--color-primary-element-light);\n  background-color: var(--color-primary-element-light);\n}\n.avatardiv .avatardiv__user-status--icon[data-v-e7e86f59] {\n  border: none;\n  background-color: transparent;\n}\n.avatardiv .popovermenu-wrapper[data-v-e7e86f59] {\n  position: relative;\n  display: inline-block;\n}\n.avatar-class-icon[data-v-e7e86f59] {\n  display: block;\n  border-radius: calc(var(--size) / 2);\n  background-color: var(--color-background-darker);\n  height: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
